import { IconLoader2 } from "@tabler/icons-react";
import { Button } from "./button";

export const LoadMore = ({ disabled, isLoading, onClick }: { disabled: boolean, isLoading: boolean, onClick: () => void }) => {
  return (
    <div className="px-4 mb-10 justify-self-center">
      <Button
        type="button"
        disabled={disabled}
        aria-busy={disabled}
        variant="primary"
        className="disabled:opacity-50 disabled:cursor-not-allowed gap-2 border-black"
        onClick={onClick}
      >
        {isLoading ? (
          <>
            <IconLoader2
              className="size-[1.125em] shrink-0 animate-spin"
              aria-hidden
            />
            Loading…
          </>
        ) : (
          "Load More"
        )}
      </Button>
    </div>
  );
};
